import { environment } from '../../environments/environment';

/**
 * Checks if the Tönnies version is available or not. Returns true if Tönnies version, otherwise false.
 */
export function isToennies(): boolean {
  return environment.toennies || false;
}
